module.exports = __webpack_public_path__ + "static/home-decor-hero-b1c824ff6272609b264e122b9516db01.png";